import React, { useState } from 'react';
import FormGroup from '@mui/material/FormGroup';
import FormControlLabel from '@mui/material/FormControlLabel';
import Checkbox from '@mui/material/Checkbox';
import OutlinedInput from '@mui/material/OutlinedInput';
import InputAdornment from '@mui/material/InputAdornment';
import IconButton from '@mui/material/IconButton';
import { ReactComponent as SearchIcon } from "assets/img/svg/SearchIcon.svg";
import styles from "../styles.module.scss";
import { CheckBox } from '../utils';

const sampleSearchParams = [
    {
        label: 'PSID',
        field: 'psid',
        placeholder: 'Enter 11 digit psid',
        regEx: ''
    },
    {
        label: 'AppId',
        field: 'appId',
        placeholder: 'Enter 8 digit appId',
        regEx: ''
    },
]

const SingleSearchInput = ({
    searchParams,
    searchHandler,
    isBulkSearch: isDisabled
}) => {
    const [selectedSearchParam, setSelectedSearchParam] = useState(searchParams?.[0])
    const [inputVal, setInputVal] = useState('');

    const handleSearch = () => {
        if(!inputVal.trim()) return;
        searchHandler({ [selectedSearchParam?.field]: inputVal })
    }

    const onKeyDownHandler = (e) => {
        if (e.key === "Enter" || e.keyCode === 13) {
            handleSearch();
        }
    };

    const handleInputChange = val => {
        const { regEx } = selectedSearchParam;
        if (isDisabled || !(regEx && regEx.test(val))) return;
        setInputVal(val)
    }

    const checkboxChangeHandler = (searchParam) => {
        setInputVal('');
        setSelectedSearchParam(searchParam)
    }

    return (
        <div className={`${styles['single-search-container']}`}>
            <FormGroup className={`${styles['radio-btn-group']}`}>
                {searchParams?.map((searchParam) => {
                    const { field, label } = searchParam;
                    const isChecked = selectedSearchParam.field === field;
                    return (<FormControlLabel
                        key={field}
                        label={<div className={styles['checkbox-label']} style={{ ...(isChecked && { fontWeight: 600 }) }}>{label}</div>}
                        control={
                            <Checkbox
                                checked={isChecked}
                                onChange={() => checkboxChangeHandler(searchParam)}
                                icon={<CheckBox type='unchecked' disabled={isDisabled} />}
                                checkedIcon={<CheckBox disabled={isDisabled} />}
                                disabled={isDisabled}
                            />
                        } />)
                }
                )}
            </FormGroup>

            <OutlinedInput
                value={inputVal}
                onChange={e => handleInputChange(e.target.value)}
                onKeyDown={onKeyDownHandler}
                endAdornment={
                    <InputAdornment position="end">
                        <IconButton
                            onClick={!isDisabled && handleSearch}
                            //   onMouseDown={handleMouseDownPassword}
                            //   onMouseUp={handleMouseUpPassword}
                            edge="end"
                        >
                            <SearchIcon />

                        </IconButton>
                    </InputAdornment>
                }
                size='small'
                sx={{
                    backgroundColor: isDisabled ? '#EEE' : '#FFF',
                    fontSize: '12px',
                    padding: '8px',
                    borderRadius: '8px',
                    width: '535px',
                    height: '45px'
                }}
                placeholder={selectedSearchParam?.placeholder}

            />

        </div>
    );
}

export default SingleSearchInput;